export default __webpack_public_path__ + "static/media/Hockey Stadium, PKL1.c38e4d0a.jpg";